import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_6d8dc575 from 'nuxt_plugin_bootstrapvue_6d8dc575' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_pluginutils_717a55b5 from 'nuxt_plugin_pluginutils_717a55b5' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_9b876c80 from 'nuxt_plugin_pluginrouting_9b876c80' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_2b86f9af from 'nuxt_plugin_pluginmain_2b86f9af' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_5c643e24 from 'nuxt_plugin_cookieuniversalnuxt_5c643e24' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_libplugin37bb4722_937438fa from 'nuxt_plugin_libplugin37bb4722_937438fa' // Source: ./lib.plugin.37bb4722.js (mode: 'all')
import nuxt_plugin_axios_551b8d46 from 'nuxt_plugin_axios_551b8d46' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_03846e3c from 'nuxt_plugin_workbox_03846e3c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_e48de416 from 'nuxt_plugin_metaplugin_e48de416' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_db3e992e from 'nuxt_plugin_iconplugin_db3e992e' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_vueperslides_53d0143c from 'nuxt_plugin_vueperslides_53d0143c' // Source: ../plugins/vueper-slides (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_vuesocialsharing_dccf00ce from 'nuxt_plugin_vuesocialsharing_dccf00ce' // Source: ../plugins/vue-social-sharing (mode: 'all')
import nuxt_plugin_vuescrollto_53dc20e5 from 'nuxt_plugin_vuescrollto_53dc20e5' // Source: ../plugins/vue-scrollto (mode: 'all')
import nuxt_plugin_vhotkey_4db62cc2 from 'nuxt_plugin_vhotkey_4db62cc2' // Source: ../plugins/v-hotkey (mode: 'all')
import nuxt_plugin_url_5e466e39 from 'nuxt_plugin_url_5e466e39' // Source: ../plugins/url (mode: 'all')
import nuxt_plugin_currency_15633587 from 'nuxt_plugin_currency_15633587' // Source: ../plugins/currency (mode: 'all')
import nuxt_plugin_date_6a7f6024 from 'nuxt_plugin_date_6a7f6024' // Source: ../plugins/date (mode: 'all')
import nuxt_plugin_jsonld_593ee954 from 'nuxt_plugin_jsonld_593ee954' // Source: ../plugins/jsonld (mode: 'all')
import nuxt_plugin_logger_52e3bef4 from 'nuxt_plugin_logger_52e3bef4' // Source: ../plugins/logger (mode: 'all')
import nuxt_plugin_plugin_528de3fc from 'nuxt_plugin_plugin_528de3fc' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../plugins/auth.js (mode: 'all')
import nuxt_plugin_analytics_2e48c327 from 'nuxt_plugin_analytics_2e48c327' // Source: ../plugins/analytics.js (mode: 'client')
import nuxt_plugin_echo_4f5a218d from 'nuxt_plugin_echo_4f5a218d' // Source: ./echo.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ru-ru"},"title":"Московская школа управления СКОЛКОВО","meta":[{"description":"№1 в Восточной Европе по качеству корпоративных программ в рейтинге Financial Times 2020"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"№1 в Восточной Европе по качеству корпоративных программ в рейтинге Financial Times 2020"},{"hid":"og:description","name":"og:description","content":"№1 в Восточной Европе по качеству корпоративных программ в рейтинге Financial Times 2020"},{"name":"facebook-domain-verification","content":"7qnxgpcih25vhln2bw5xi0wjko30p7"}],"link":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_6d8dc575 === 'function') {
    await nuxt_plugin_bootstrapvue_6d8dc575(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_717a55b5 === 'function') {
    await nuxt_plugin_pluginutils_717a55b5(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_9b876c80 === 'function') {
    await nuxt_plugin_pluginrouting_9b876c80(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_2b86f9af === 'function') {
    await nuxt_plugin_pluginmain_2b86f9af(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_5c643e24 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_5c643e24(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin37bb4722_937438fa === 'function') {
    await nuxt_plugin_libplugin37bb4722_937438fa(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_551b8d46 === 'function') {
    await nuxt_plugin_axios_551b8d46(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_03846e3c === 'function') {
    await nuxt_plugin_workbox_03846e3c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_e48de416 === 'function') {
    await nuxt_plugin_metaplugin_e48de416(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_db3e992e === 'function') {
    await nuxt_plugin_iconplugin_db3e992e(app.context, inject)
  }

  if (typeof nuxt_plugin_vueperslides_53d0143c === 'function') {
    await nuxt_plugin_vueperslides_53d0143c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharing_dccf00ce === 'function') {
    await nuxt_plugin_vuesocialsharing_dccf00ce(app.context, inject)
  }

  if (typeof nuxt_plugin_vuescrollto_53dc20e5 === 'function') {
    await nuxt_plugin_vuescrollto_53dc20e5(app.context, inject)
  }

  if (typeof nuxt_plugin_vhotkey_4db62cc2 === 'function') {
    await nuxt_plugin_vhotkey_4db62cc2(app.context, inject)
  }

  if (typeof nuxt_plugin_url_5e466e39 === 'function') {
    await nuxt_plugin_url_5e466e39(app.context, inject)
  }

  if (typeof nuxt_plugin_currency_15633587 === 'function') {
    await nuxt_plugin_currency_15633587(app.context, inject)
  }

  if (typeof nuxt_plugin_date_6a7f6024 === 'function') {
    await nuxt_plugin_date_6a7f6024(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_593ee954 === 'function') {
    await nuxt_plugin_jsonld_593ee954(app.context, inject)
  }

  if (typeof nuxt_plugin_logger_52e3bef4 === 'function') {
    await nuxt_plugin_logger_52e3bef4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_528de3fc === 'function') {
    await nuxt_plugin_plugin_528de3fc(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_2e48c327 === 'function') {
    await nuxt_plugin_analytics_2e48c327(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_echo_4f5a218d === 'function') {
    await nuxt_plugin_echo_4f5a218d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
